import { Skeleton } from 'antd';

export function FormSkeleton() {
    return (
        <div className="w-full p-6 sm:p-10 bg-white rounded-xl shadow-sm box-shadow-sm animate-pulse grid gap-6">
            {/* Title placeholder */}
            <Skeleton.Input
                active
                block
                size="default"
                className="w-28 rounded-lg"
            />

            {/* Two columns rows */}
            <div className="grid gap-4 sm:grid-cols-2">
                <Skeleton.Input
                    active
                    block
                    size="large"
                    className="w-full rounded-lg"
                />
                <Skeleton.Input
                    active
                    block
                    size="large"
                    className="w-full rounded-lg"
                />
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
                <Skeleton.Input
                    active
                    block
                    size="large"
                    className="w-full rounded-lg"
                />
                <Skeleton.Input
                    active
                    block
                    size="large"
                    className="w-full rounded-lg"
                />
            </div>

            {/* Large text area */}
            <Skeleton.Input
                active
                block
                size="large"
                className="w-full h-28 rounded-lg"
            />

            <div className="grid gap-4 sm:grid-cols-2">
                <Skeleton.Input
                    active
                    block
                    size="large"
                    className="w-full rounded-lg"
                />
                <Skeleton.Input
                    active
                    block
                    size="large"
                    className="w-full rounded-lg"
                />
            </div>

            {/* Button placeholder aligned right */}
            <div className="flex justify-end">
                <Skeleton.Button
                    active
                    block
                    size="small"
                    className="w-20 rounded-lg"
                />
            </div>
        </div>
    );
}
